"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkTypeEnum = void 0;
var LinkTypeEnum;
(function (LinkTypeEnum) {
    LinkTypeEnum["LOSER"] = "LOSER";
    LinkTypeEnum["WINNER"] = "WINNER";
    LinkTypeEnum["POSITION"] = "POSITION"; // link is dependent on finishing position, typically within a ROUND ROBIN group
})(LinkTypeEnum || (exports.LinkTypeEnum = LinkTypeEnum = {}));
//# sourceMappingURL=link_type.js.map